import useSWR from 'swr';
import useCustomerId from './useCustomerId';

/**
 * Obtains a list of categories by company
 * @param {object} params
 * @param {boolean} [params.allowRequest]
 * @param {number | string} [params.customerId] Company to query. Falls back to the selected customer when omitted.
 */
const useCategoriesByCustomer = ({ allowRequest = true, customerId: customerIdParam } = {}) => {
  const { customerId: customerIdFromContext } = useCustomerId();
  const customerId = customerIdParam !== undefined ? customerIdParam : customerIdFromContext;

  const { data, isLoading, error } = useSWR(
    () => (allowRequest && customerId ? `/v2/partner/categories/${customerId}` : false),
    {
      revalidateOnFocus: false,
    }
  );
  return { data: data || [], isLoading, error };
};
export default useCategoriesByCustomer;
